<template>
  <div>
    <ul-form ref="editForm" :model="testForm" :rules="rules" label-width="80px">
      <ul-form-item :label="$t('pages_components_info_701')" prop="title">
        <ul-input
          v-model="testForm.title"
          :placeholder="$t('pages_components_info_702')"
        ></ul-input>
      </ul-form-item>
      <ul-form-item :label="$t('pages_components_info_703')" prop="cover">
        <!-- 使用 ref 触发选择，避免与「创建实验」弹窗重复的 id="avatar" 导致编辑时上传到错误表单 -->
        <label class="uploading" @click.prevent="triggerCoverUpload">{{
          $t("pages_components_info_710")
        }}</label>
        <input
          ref="coverInput"
          v-show="false"
          type="file"
          style="position: absolute; clip: rect(0 0 0 0)"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg($event)"
        />
        <span class="hint">{{ $t("pages_components_info_711") }}</span>
        <img
          v-if="testForm.cover"
          class="cover"
          :src="testForm.cover"
          :key="testForm.cover"
        />
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_components_info_704')"
        prop="studytime"
        v-if="type != 2"
      >
        <ul-input
          class="score-input"
          v-model="testForm.studytime"
          :placeholder="$t('pages_components_info_705')"
          type="number"
        />
        <span class="hint">{{ $t("pages_components_info_712") }}</span>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_components_info_706')"
        prop="url"
        v-if="type != 2"
      >
        <ul-input
          v-model="testForm.url"
          :placeholder="$t('pages_components_info_707')"
        ></ul-input>
      </ul-form-item>
      <div class="hint-url" v-if="type != 2">
        {{ $t("pages_components_info_713") }}
      </div>
      <div class="link" v-if="type != 2">
        <a
          :href="require('@/assets/file/virtual.docx')"
          :download="$t('pages_components_info_708')"
          >{{ $t("pages_components_info_714") }}</a
        >
      </div>
      <ul-form-item
        :label="$t('pages_components_info_709')"
        prop="fileList"
        v-if="type == 2"
      >
        <file-list
          :list="testForm.fileList"
          @update="editFileUpdate"
        ></file-list>
      </ul-form-item>
    </ul-form>
    <cropper ref="cropperDialog" @upData="upDataPicurl"></cropper>
  </div>
</template>

<script>
import cropper from "../../components/cropper.vue";
import fileList from "./fileList.vue";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  components: {
    cropper,
    fileList,
  },
  data() {
    return {
      testForm: {
        title: "",
        cover: "",
        studytime: "",
        url: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("pages_components_info_715"),
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$t("pages_components_info_716"),
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: this.$t("pages_components_info_717"),
            trigger: "blur",
          },
        ],
        studytime: [
          {
            required: true,
            message: this.$t("pages_components_info_718"),
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("pages_components_info_719"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && typeof val === "object") {
          this.testForm = val;
        }
      },
    },
  },
  methods: {
    triggerCoverUpload() {
      const input = this.$refs.coverInput;
      if (input) {
        input.click();
      }
    },
    uploadImg(e) {
      const input = e.target;
      if (!input || !input.files || input.files.length === 0) {
        return;
      }
      const data = {
        title: this.$t("pages_components_info_720"),
      };
      this.$refs.cropperDialog.uploadImg(e, data);
      // 允许重复选择同一文件
      input.value = "";
    },
    upDataPicurl(url) {
      // 与父级 componentData 同一引用，使用 $set 保证封面字段可响应更新
      this.$set(this.testForm, "cover", url);
    },
    editFileUpdate(list) {
      this.testForm.fileList = list;
    },
  },
};
</script>

<style lang="scss" scoped>
.score-input {
  width: 110px;
  margin-right: 10px;
}
.hint {
  color: #969696;
}
.hint-url {
  color: #969696;
  font-size: 12px;
  line-height: 1.5;
  margin: 10px 0;
  padding-left: 80px;
}
.link {
  padding-left: 80px;
  color: #8d77fb;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
}
.uploading {
  color: #8d77fb;
  cursor: pointer;
  margin-right: 12px;
}
.cover {
  display: block;
  width: 120px;
}
</style>